import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const NEWSLETTER_DEFAULTS = {
    title: "Stay in the loop",
    subtitle: "One short email, once a month. No spam — unsubscribe any time.",
    placeholder: "you@example.com",
    buttonText: "Subscribe",
    action: "/api/subscribe",
    method: "POST",
    fieldName: "email",
    note: "We'll never share your email.",
    layout: "centered-card",
    background: "#f8fafc",
    textColor: "#0f172a",
    accent: "#111827",
    radius: 12,
};
export const newsletterWidget = {
    type: "newsletter",
    defaultProps: NEWSLETTER_DEFAULTS,
    renderHtml(props) {
        const layout = props.layout ?? "centered-card";
        const bg = props.background ?? "#f8fafc";
        const text = props.textColor ?? "#0f172a";
        const accent = props.accent ?? "#111827";
        const radius = props.radius ?? 12;
        const method = props.method ?? "POST";
        const field = props.fieldName ?? "email";
        const inputStyle = "flex:1;min-width:0;padding:12px 14px;border:1px solid rgba(0,0,0,0.15);border-radius:8px;font-size:15px;font-family:inherit;color:#0f172a;background:#ffffff;box-sizing:border-box";
        const buttonStyle = `padding:12px 22px;background:${accent};color:#fff;border:1px solid ${accent};border-radius:8px;font-size:15px;font-weight:500;font-family:inherit;cursor:pointer`;
        const input = `<input type="email" name="${escapeAttr(field)}" required placeholder="${escapeAttr(props.placeholder)}" style="${inputStyle}">`;
        const button = `<button type="submit" style="${buttonStyle}">${escapeHtml(props.buttonText)}</button>`;
        const note = props.note
            ? `<p style="margin:8px 0 0;font-size:12px;color:${text};opacity:0.6">${escapeHtml(props.note)}</p>`
            : "";
        const formAttrs = `action="${escapeAttr(props.action)}" method="${method}" novalidate`;
        if (layout === "inline") {
            return `<form class="emk-newsletter emk-newsletter--inline" ${formAttrs} style="font-family:inherit;display:flex;gap:8px;flex-wrap:wrap;align-items:stretch">${input}${button}</form>${note ? `<div style="margin-top:4px">${note}</div>` : ""}`;
        }
        const title = props.title
            ? `<h3 style="margin:0;font-size:22px;font-weight:600;line-height:1.3;color:${text}">${escapeHtml(props.title)}</h3>`
            : "";
        const subtitle = props.subtitle
            ? `<p style="margin:8px 0 16px;font-size:15px;line-height:1.55;color:${text};opacity:0.75">${escapeHtml(props.subtitle)}</p>`
            : "";
        const wrapStyle = [
            `background:${bg}`,
            `color:${text}`,
            "padding:32px 24px",
            `border-radius:${radius}px`,
            "font-family:inherit",
            layout === "centered-card" ? "max-width:560px;margin:0 auto;text-align:center" : "",
        ]
            .filter(Boolean)
            .join(";");
        const form = `<form ${formAttrs} style="display:flex;gap:8px;flex-wrap:wrap;${layout === "centered-card" ? "justify-content:center" : ""}">${input}${button}</form>`;
        return `<div class="emk-newsletter emk-newsletter--${layout}" style="${wrapStyle}">${title}${subtitle}${form}${note}</div>`;
    },
};
//# sourceMappingURL=newsletter.js.map